import EditRespondentDialog from './EditRespondentDialog';

export default EditRespondentDialog;